import React, { Component } from 'react';
import { Icon, Radio, Tooltip } from 'antd';
import { find } from 'lodash';
import Modal from '../../../../../common/component/Modal';
import Input from '../../../../../common/component/Input';
import Wrapper from '../../../../../common/component/Wrapper';
import Span from '../../../../../common/component/Span';
import './styles.less';

export const TRANSLATE_LANGUAGES = [
    { code: 'vi-VN', label: 'VI' },
    { code: 'en-US', label: 'EN' },
    { code: 'ko-KR', label: 'KO' },
    { code: 'zh-CN', label: 'CN' },
    { code: 'ru-RU', label: 'RU' },
];

export const DEFAULT_LANGUAGE_CODE = 'vi-VN';

export const getLanguageLabel = (languageCode) => {
    const lang = find(TRANSLATE_LANGUAGES, item => item.code === languageCode);
    return lang ? lang.label : languageCode;
};

export const getDefaultTranslation = (translations = []) => {
    return find(translations, item => item.isDefault)
        || find(translations, item => item.languageCode === DEFAULT_LANGUAGE_CODE)
        || translations[0];
};

export default class MultiLanguageInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowModal: false,
            names: {},
            defaultLanguageCode: DEFAULT_LANGUAGE_CODE,
        };
    }

    getDefaultLanguageCode = () => {
        const { translations } = this.props;
        const defaultTranslation = getDefaultTranslation(translations || []);
        return defaultTranslation?.languageCode || DEFAULT_LANGUAGE_CODE;
    }

    onOpenModal = () => {
        const { value, translations } = this.props;
        const defaultLanguageCode = this.getDefaultLanguageCode();
        const names = {};
        TRANSLATE_LANGUAGES.forEach(lang => {
            const translation = find(translations || [], item => item.languageCode === lang.code);
            names[lang.code] = translation?.name || '';
        });
        names[defaultLanguageCode] = value || '';
        this.setState({ isShowModal: true, names, defaultLanguageCode });
    }

    onCloseModal = () => {
        this.setState({ isShowModal: false });
    }

    onChangeName = (languageCode, name) => {
        this.setState({ names: { ...this.state.names, [languageCode]: name } });
    }

    onChangeDefaultLanguage = (languageCode) => {
        this.setState({ defaultLanguageCode: languageCode });
    }

    buildTranslations = (names, defaultLanguageCode) => {
        const { translations } = this.props;
        const result = [];
        TRANSLATE_LANGUAGES.forEach(lang => {
            const name = names[lang.code] || '';
            const isDefault = lang.code === defaultLanguageCode;
            if (!name.trim() && !isDefault) return;
            const translation = find(translations || [], item => item.languageCode === lang.code) || {};
            result.push({
                id: translation.id,
                rateCodeId: translation.rateCodeId,
                rateCodeSlotServiceId: translation.rateCodeSlotServiceId,
                description: translation.description,
                name,
                languageCode: lang.code,
                isDefault,
            });
        });
        return result;
    }

    onSubmitModal = () => {
        const { names, defaultLanguageCode } = this.state;
        this.props.onChange(names[defaultLanguageCode] || '', this.buildTranslations(names, defaultLanguageCode));
        this.setState({ isShowModal: false });
    }

    onChangeValue = (value) => {
        const { translations } = this.props;
        const defaultLanguageCode = this.getDefaultLanguageCode();
        const names = {};
        TRANSLATE_LANGUAGES.forEach(lang => {
            const translation = find(translations || [], item => item.languageCode === lang.code);
            names[lang.code] = translation?.name || '';
        });
        names[defaultLanguageCode] = value;
        this.props.onChange(value, this.buildTranslations(names, defaultLanguageCode));
    }

    renderModal = () => {
        const { t, modalTitle } = this.props;
        const { isShowModal, names, defaultLanguageCode } = this.state;
        return (
            <Modal
                visible={isShowModal}
                className="multi-language-modal"
                title={<Span><Icon type="global" className="mr-2" />{modalTitle || t('item.ratecode.translateSetting')}</Span>}
                okText={t('action.update')}
                cancelText={t('action.cancel')}
                onOk={this.onSubmitModal}
                onCancel={this.onCloseModal}
                destroyOnClose
            >
                {TRANSLATE_LANGUAGES.map(lang => (
                    <Wrapper key={lang.code} className="multi-language-modal-item">
                        <Wrapper className="multi-language-modal-item-label">
                            <Span className="language-code">{lang.label}</Span>
                            <Radio
                                checked={defaultLanguageCode === lang.code}
                                onChange={() => this.onChangeDefaultLanguage(lang.code)}
                            >
                                {t('translate.defaultLanguage')}
                            </Radio>
                        </Wrapper>
                        <Input type="text"
                            autoComplete="off"
                            className="form-control"
                            placeholder={t('placeHolderForm.input')}
                            value={names[lang.code] || ''}
                            onChange={e => this.onChangeName(lang.code, e.target.value)}
                        />
                    </Wrapper>
                ))}
            </Modal>
        )
    }

    render() {
        const { t, value, placeholder, disabled, name } = this.props;
        const defaultLanguageCode = this.getDefaultLanguageCode();
        return (
            <Wrapper className="multi-language-input">
                <Input type="text"
                    autoComplete="off"
                    className="form-control"
                    name={name}
                    disabled={disabled}
                    placeholder={placeholder}
                    value={value || ''}
                    onChange={e => this.onChangeValue(e.target.value)}
                />
                <Tooltip title={t('item.ratecode.translateSetting')}>
                    <Span className="multi-language-input-button" onClick={this.onOpenModal}>
                        <Icon type="global" />
                        <Span className="language-code">{getLanguageLabel(defaultLanguageCode)}</Span>
                    </Span>
                </Tooltip>
                {this.renderModal()}
            </Wrapper>
        )
    }
}

MultiLanguageInput.defaultProps = {
    translations: [],
    onChange: () => { },
};
